/**
 * Wrap an existing Expedia URL in our Partnerize click-tracking prefix.
 *
 * Tracked on Expedia's own domain (Partnerize custom-domain tracking) so adblockers don't strip the
 * click; links built with the old `prf.hn/click/camref:1100lwgQV/destination:` prefix still redirect.
 * Used for a freshly-built Expedia search link (utils/parners.ts, SidebarAccommodationActivityMenu.tsx)
 * and for a stored/deep Expedia URL (utils/urlUtils.ts stampAffiliateUrl).
 */
export const EXPEDIA_TRACKING_PATH = "/partnernetwork/p/gp/camref:1100lwgQV/";

const EXPEDIA_PARTNERIZE_PREFIX = `https://www.expedia.com${EXPEDIA_TRACKING_PATH}destination:`;

export const wrapExpediaUrl = (url: string): string => `${EXPEDIA_PARTNERIZE_PREFIX}${encodeURIComponent(url)}`;
